module.exports = __webpack_public_path__ + "img/swiper-22.60ca92dd.png";